import {UnitsContext} from "../../../index";
import {distanceValueToShow} from "../../../util/distance";
import {dateFormat, formatDate} from "../../../util/time";
import {useContext} from "react";

export const FORMAT_FLOAT = (value) => {
    return (value && value > 0) ? parseFloat(value).toFixed(0) : null
}

export const FORMAT_DISTANCE = (value) => {
    let units = useContext(UnitsContext).units;
    return (value && value > 0) ? distanceValueToShow(units, value) : null
}

export const FORMAT_DATE = (value) => {
    let units = useContext(UnitsContext).units;
    return (value && value > 0) ? formatDate(new Date(value * 1000), dateFormat(units)) : null
}
